const fetch = require('node-fetch');

let citiesWithHolidays = {};
let initialized = false;

class CityHolidayService {
  static async downloadHolidays() {
    const response = await fetch(`https://transfeeradata.s3.amazonaws.com/bank-holidays/city-holidays.json`);

    citiesWithHolidays = await response.json();

    initialized = true;

    return this;
  }

  getCityHolidays(cityCode) {
    if (!initialized) {
      throw new Error('CityHolidayService not initialized');
    }

    return citiesWithHolidays[cityCode];
  }
}

module.exports = CityHolidayService;
